module.exports = __webpack_public_path__ + "img/sv4.245b4981.png";